import {
  Button,
  CaptionText,
  Col,
  Row,
  HeadingText,
  BodyText,
  Link,
  PlayIcon,
} from '@paypalcorp/pp-react'
import React from 'react'
import { Message, injectWorldReady } from '@paypalcorp/worldready-react'
import setupDevAccountImg from '../../../img/payment-solutions/setup_dev_account.png'

const Play = () => {
  return (
    <div className="banner-play_button">
      <PlayIcon />
    </div>
  )
}

function LiveCredentialsFromClient({ setIsCredsForClient }) {
  return (
    <>
      <Row>
        <Col xs={10} className="banner-title_row">
          <HeadingText size="sm">
            <Message id="onboarding-banner.liveCredentialsTitle" />
          </HeadingText>
        </Col>
      </Row>
      <Row>
        <Col xs={7}>
          <BodyText>
            <Message id="onboarding-banner.liveCredentialsText1" />
          </BodyText>
          <br />
          <BodyText>
            <Message
              id="onboarding-banner.liveCredentialsText2"
              strong={(impLabel) => <strong> {impLabel} </strong>}
            />
          </BodyText>
        </Col>
        <Col xs={4.5}>
          <Row className="banner-video_background">
            <Col xs={4} className="banner-image_container">
              <Link
                target="_blank"
                href="https://youtu.be/O_9G722SpXQ?t=120"
                className="banner-image_link"
                rel="noreferrer"
              >
                <Play />
                <img
                  src={setupDevAccountImg}
                  alt="How to setup a developer account"
                  width="130"
                  height="74"
                  className="banner-video_image"
                />
              </Link>
            </Col>
            <Col className="banner-video_container" xs={7}>
              <BodyText size="sm" strong>
                <Message id="onboarding-banner.liveCredentialsVideoText" />
              </BodyText>
              <CaptionText className="banner-video_time">
                <Message id="onboarding-banner.liveCredentialsVideoTimeText" />
              </CaptionText>
            </Col>
          </Row>
        </Col>
      </Row>
      <br />
      <Row>
        <Col>
          <Button
            secondary
            size="md"
            onClick={() => setIsCredsForClient(false)}
          >
            <Message id="onboarding-banner.liveCredentialsButton" />
          </Button>
        </Col>
      </Row>
    </>
  )
}

export default injectWorldReady(LiveCredentialsFromClient)
